<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('loadingProducts')">Carico</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Crea <br />
    </h1>
    <!-- 
    <h2 class="mb-8 text-xl">
      <span v-for="batch in batches.data" :key="batch.id" :value="batch.id">{{ batch.nome }} - {{ batch.count_product }}<br /></span>
    </h2> -->

    <div class="bg-white rounded-md shadow overflow-hidden max-w-5xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 mb-8 flex flex-wrap">
          <text-input v-model="form.sku" :error="form.errors.sku" class="pr-6 pb-8 w-full lg:w-1/3" label="SKU" />
          <!-- <select-input v-model="form.batch_id" :error="form.errors.batch_id" class="pr-6 pb-8 w-full lg:w-1/3" label="Lotto">
            <option :value="null" />
            <option v-for="batch in batches" :key="batch.id" :value="batch.id">{{ batch.nome }}</option>
          </select-input> -->
          <multiselect v-model="selectedBatch" id="batch_id" placeholder="Cerca lotto" :options="batches" label="nome" track-by="id" @search-change="onSearchBatchesChange" @input="onSelectedBatch" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Crea Carico</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import { StreamBarcodeReader } from 'vue-barcode-reader'
import { ImageBarcodeReader } from 'vue-barcode-reader'
import Multiselect from 'vue-multiselect'

export default {
  metaInfo: { title: 'Crea Carico' },
  components: {
    LoadingButton,
    SelectInput,
    StreamBarcodeReader,
    TextInput,
    Multiselect,
  },
  layout: Layout,
  props: {
    batches: Object,
  },
  remember: 'form',
  data() {
    return {
      selectedBatch: undefined,
      form: this.$inertia.form({
        sku: null,
        batch_id: null,
      }),
    }
  },
  methods: {
    store() {
      if (navigator.onLine) {
        this.form.post(this.route('loadingProducts.store')), this.form.reset('sku'), this.form.focus('sku')
      } else {
        this.$page.props.flash.error = 'Controllare la connessione e ricaricare la pagina'
      }
    },
    onDecode(text) {
      console.log(`Decode text from QR code is ${text}`)
    },
    onLoaded() {
      console.log(`Ready to start scanning barcodes`)
    },
    onSearchBatchesChange(term) {
        this.$inertia.get('/batches/getBatches', {term}, {
            preserveState: true,
            preserveScroll: true,
            replace: true
        })
    },
    onSelectedBatch(batch) {
    this.form.batch_id = batch.id;
    }
  },
}
</script>
